/* eslint-disable react/prop-types */
import { IconButton, TableCell, TableRow, TextField } from "@material-ui/core"

import React, { useMemo, useContext } from "react"
import { Delete } from "@material-ui/icons"
import InvoiceFormContext from "./InvoiceFormContex"
import { currencyOperation, invoiceNumberFormat } from "./utils"

function InvoiceDownPaymentRow({
  item,
  index,
  register,
  errors,
  showRemark = false,
  showDelete = false,
  onDeleteButtonClick = () => {},
}) {
  const {
    selectedCurrency,
    paymentPercentage,
    currencyRate,
    rateIn,
  } = useContext(InvoiceFormContext)

  const totalCostWithCurrency = useMemo(() => {
    return currencyOperation(item.totalCost, rateIn, currencyRate)
  }, [currencyRate, item.totalCost, rateIn])
  const totalCostWithPercentage = useMemo(() => {
    if (!paymentPercentage) return totalCostWithCurrency
    return totalCostWithCurrency * (0 + paymentPercentage / 100)
  }, [paymentPercentage, totalCostWithCurrency])

  const getFormAttribute = (name) => {
    const errorObj = (errors[index] || {})[name]
    return {
      name: `productDescriptions[${index}].${name}`,
      defaultValue: item[name],
      inputRef: register,
      error: !!errorObj,
      helperText: errorObj?.message,
      variant: "outlined",
      fullWidth: true,
      margin: "dense",
    }
  }
  return (
    <TableRow>
      <TableCell>{item.slsQuot?.slsQuotNumber}</TableCell>
      <TableCell>{item.slsQuot?.poNumber}</TableCell>
      <TableCell>
        <TextField {...getFormAttribute("description")} multiline />
        <input
          type="hidden"
          name={`productDescriptions[${index}].slsEstimateId`}
          value={item.slsEstimateId}
          ref={register}
        />
      </TableCell>
      <TableCell>
        {new Intl.NumberFormat().format(item.quantity)}
        <input
          type="hidden"
          name={`productDescriptions[${index}].quantity`}
          value={item.quantity}
          ref={register}
        />
      </TableCell>
      <TableCell>
        {item.uom?.name}
        <input
          type="hidden"
          name={`productDescriptions[${index}].unit`}
          value={item.uom?.name}
          ref={register}
        />
      </TableCell>
      <TableCell style={{ textAlign: "right" }}>
        {selectedCurrency?.code}{" "}
        {invoiceNumberFormat(
          Math.ceil(totalCostWithCurrency / item.quantity),
          selectedCurrency?.code
        )}
        <input
          type="hidden"
          name={`productDescriptions[${index}].unitPrice`}
          value={item.totalCost}
          ref={register}
        />
      </TableCell>

      <TableCell style={{ textAlign: "right" }}>
        {selectedCurrency?.code}{" "}
        {invoiceNumberFormat(
          Math.ceil(totalCostWithPercentage),
          selectedCurrency?.code
        )}
      </TableCell>
      <TableCell>
        <TextField
          {...getFormAttribute("sequence")}
          defaultValue={item.sequence || index + 1}
          type="number"
        />
      </TableCell>
      {showRemark && (
        <TableCell>
          <TextField
            {...getFormAttribute("remark")}
            multiline
            style={{ width: "15rem" }}
          />
        </TableCell>
      )}
      {showDelete ? (
        <TableCell>
          <IconButton onClick={() => onDeleteButtonClick(index)}>
            <Delete />
          </IconButton>
        </TableCell>
      ) : null}
    </TableRow>
  )
}

export default InvoiceDownPaymentRow
